import { FC } from 'react';
import { Box, BoxProps } from '@chakra-ui/react';

import Accordion from 'components/_core/Accordion';
import Text from 'components/_core/Text';

import locales from './locales';

interface PhysicalCardQuotaReachedFaqProps extends BoxProps {
  cardNumber: string;
}

const PhysicalCardQuotaReachedFaq: FC<PhysicalCardQuotaReachedFaqProps> = ({
  cardNumber,
  ...props
}) => (
  <Box {...props}>
    <Text marginBottom="space-16" size="sm" variant="light">
      {locales.subtitle}
    </Text>

    <Accordion>
      <Accordion.Item title={locales.title}>
        <Accordion.Text>
          {locales.content} {cardNumber}
          {locales.contentSuffix}
        </Accordion.Text>
      </Accordion.Item>
    </Accordion>
  </Box>
);

export default PhysicalCardQuotaReachedFaq;
